import { render } from "./AciasSection.vue?vue&type=template&id=731d40ca&scoped=true"
import script from "./AciasSection.vue?vue&type=script&lang=js"
export * from "./AciasSection.vue?vue&type=script&lang=js"

import "./AciasSection.vue?vue&type=style&index=0&id=731d40ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731d40ca"]])

export default __exports__